import React, { useEffect, useState } from "react";
import { useGetSuppliersQuery } from "../../store/api/supplierApi";
import {
  useCreateProductMutation,
  useDeleteProductMutation,
  useGetProductsQuery,
  useUpdateProductMutation,
} from "../../store/api/productsApi";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaRegEdit,
} from "react-icons/fa";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { BsFillCameraFill, BsTrashFill } from "react-icons/bs";
import { Tooltip } from "react-tooltip";
import DataTable from "react-data-table-component";
import { IoSearch } from "react-icons/io5";
import { useGetCategoryQuery } from "../../store/api/categoryApi";
import { useGetUnitsQuery } from "../../store/api/UnitsApi";
import {
  useGetAllRequestedQuery,
  useGetOrderProductsQuery,
} from "../../store/api/orderProductApi";
import { FaDownLong } from "react-icons/fa6";
import ExportStockCheckExcel from "../tools/StockCheckReport";

const initialProduct = {
  Id: 0,
  name: "",
  supplierId: null,
  isActive: true,
  Quantity: 0,
  notifyQty: 2,
  amount: 0,
  CategoryId: "",
  UnitesId: "",
};

export default function Product() {
  const [isUpdate, setIsUpdate] = useState(false);

  const [CreateProduct] = useCreateProductMutation();
  const [updateProduct] = useUpdateProductMutation();
  const [deleteProduct] = useDeleteProductMutation();
  const { refetch: refetchNotifications } = useGetNotificationsQuery();
  const [categories, setCategoriesList] = useState([]);
  const [Units, setUnitsList] = useState([]);
  const { data: CategoriesList } = useGetCategoryQuery();
  const { data: UnitsList } = useGetUnitsQuery();
  const [productsList, setProductsList] = useState([]);
  const { data: productList, refetch: refetchProductList } =
    useGetProductsQuery();

  const { refetch: refetchAllRequested } = useGetAllRequestedQuery({
    refetchOnMountOrArgChange: false,
  });

  const { refetch: refetchOrderProducts } = useGetOrderProductsQuery();

  useEffect(() => {
    if (CategoriesList) {
      setCategoriesList(CategoriesList);
    }
  }, [CategoriesList]);

  useEffect(() => {
    if (UnitsList) {
      setUnitsList(UnitsList);
    }
  }, [UnitsList]);

  // products  . . .
  const [products, setProducts] = useState(initialProduct);
  const [file, setFile] = useState(null);

  // select file for the new product
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  // create new product method
  const handleCreateProduct = async (event) => {
    event.preventDefault();

    const productData = {
      Name: products.name,
      Quantity: products.Quantity,
      ImageFiles: file,
      supplierId: products.supplierId,
      isActive: products.isActive,
      notifyQty: products.notifyQty,
      amount: products.amount,
      CategoryId: products.CategoryId,
      UnitesId: products.UnitesId,
    };

    const response = await CreateProduct(productData);

    if (response.data.status === 200) {
      await refetchNotifications();
      resetFormData();
      if (response.data.status === 200) {
        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "Done",
        });
      } else {
        Swal.fire({
          title: "error!",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    } else {
      console.log(response.data.message);
    }

    resetFormData();
  };

  // reading product list

  useEffect(() => {
    if (productList && Array.isArray(productList)) {
      setProductsList(productList);
    }
  }, [productList]);

  // delete product
  const handleDelete = (value) => {
    const { id } = value;
    Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this product !!!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteProduct(id).then((done) => {
          if (done?.data.status === 200) {
            refetchNotifications();
            Swal.fire({
              title: "Success!",
              text: done.data.message,
              icon: "success",
              confirmButtonText: "Done",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: done.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      }
    });
  };

  const handleUpdate = (updateData) => {
    if (!isUpdate) {
      setIsUpdate(!isUpdate);
    }

    setProducts({
      Id: updateData.id,
      name: updateData.name,
      fileName: updateData.imageUrls,
      supplierId: updateData.supId,
      Quantity: updateData.qty,
      notifyQty: updateData.notifyQty,
      isActive: updateData.isActive === "active" ? true : false,
      amount: updateData.amount,
      CategoryId: updateData.categoryId,
      UnitesId: updateData.unitesId,
    });
  };

  // search products
  const searchProducts = (searchText) => {
    if (!searchText) {
      return products;
    }

    const filteredProducts = productsList.filter((product) => {
      const nameMatch = product.name
        .toLowerCase()
        .includes(searchText.toLowerCase());
      const quantityMatch = product.qty.toString() === searchText;
      const statusMatch =
        product.isActive.toLowerCase() === searchText.toLowerCase();
      return nameMatch || quantityMatch || statusMatch;
    });

    return filteredProducts;
  };

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [formData, setFormData] = useState([]);

  // changes pages
  const handlePageChange = (page) => {
    setPage(page);
  };

  // change perpage
  const handlePerPageChange = (perPage) => {
    setPerPage(perPage);
  };

  const ResetFormChanges = () => {
    setIsUpdate(!isUpdate);
    setProducts(initialProduct);
    setFile(null);
  };

  // search hanlder
  const handleSearch = (e) => {
    setFormData(searchProducts(e.target.value));
  };

  const handleUpdateProduct = async (event) => {
    setIsUpdate(!isUpdate);
    event.preventDefault();

    const productData = {
      Id: products.Id,
      Name: products.name,
      Quantity: products.Quantity,
      ImageFiles: file,
      supplierId: products.supplierId,
      isActive: products.isActive,
      notifyQty: products.notifyQty,
      amount: products.amount,
      CategoryId: products.CategoryId,
      UnitesId: products.UnitesId,
    };

    const response = await updateProduct(productData);
    if (response.data.status === 200) {
      Swal.fire({
        title: "Success!",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "Done",
      });
    } else {
      Swal.fire({
        title: "Error!",
        text: response.data.message,
        icon: "error",
        confirmButtonText: "Close",
      });
    }
    await refetchNotifications();
    await refetchProductList();
    await refetchAllRequested();
    await refetchOrderProducts();
    setProducts(initialProduct);
    resetFormData();
  };

  const resetFormData = () => {
    setProducts({
      ...initialProduct,
    });
    setFile(null);
  };

  const handlePrint = () => {
    ExportStockCheckExcel(productsList);
  };

  // Table columns
  const _columns = [
    { name: "Id", selector: (row) => row.id, sortable: true, center: true },
    {
      name: "Image",
      selector: (row) => row.imageUrls,
      cell: (row) => (
        <img
          src={`${row.imageUrls}?timestamp=123456789`}
          alt=""
          width="50"
          className="zoom-on-hover border border-2 rounded-1 m-1"
        />
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },

    {
      name: "Quanity",
      selector: (row) => row.qty,
      sortable: true,
      center: true,
      cell: (row) => (
        <>
          {row.qty <= row.notifyQty ? (
            <Link
              data-tooltip-id={`quantityTooltip-${row.id}`}
              data-tooltip-content="Low quantity!"
              className="d-inline-block d-flex align-items-center text-decoration-none fw-bold text-danger"
            >
              <FaExclamationTriangle className="text-warning me-2" />
              {row.qty}
            </Link>
          ) : (
            row.qty
          )}
          <Tooltip
            id={`quantityTooltip-${row.id}`}
            place="top"
            effect="solid"
            delayShow={200}
          />
        </>
      ),
    },
    {
      name: "Alert Quantity",
      selector: (row) => row.notifyQty,
      sortable: true,
      center: true,
    },
    {
      name: "Amount",
      selector: (row) => `$${row.amount}`,
      sortable: true,
      center: true,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
      center: true,
    },
    {
      name: "Units",
      selector: (row) => row.unit,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.isActive,
      cell: (row) =>
        row.isActive === "active" ? (
          <div className="w-100 p-1 rounded-5 bg-success opacity-75  text-center text-white  text-capitalize">
            {row.isActive}
          </div>
        ) : (
          <span className="w-100 p-1 rounded-5 bg-danger opacity-50  text-center text-white  text-capitalize">
            {row.isActive}
          </span>
        ),
      sortable: true,
      center: true,
    },
    {
      name: "Create At",
      selector: (row) => row.created,
      sortable: true,
      center: true,
    },
    {
      name: "Updated At",
      selector: (row) => row.updated,
      sortable: true,
      center: true,
    },

    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            style={{ background: "#1a2131" }}
            className="btn btn-success me-3 border-0  text-white"
            onClick={() => handleUpdate(row)}
          >
            <FaRegEdit />
          </button>

          <button
            style={{ background: "#A0374F" }}
            className="btn btn-danger text-white border-0"
            onClick={() => handleDelete(row)}
          >
            <BsTrashFill />
          </button>
        </>
      ),
      center: true,
    },
  ];

  const paginatedData = formData.length
    ? formData.slice((page - 1) * perPage, page * perPage)
    : productsList.slice((page - 1) * perPage, page * perPage);

  const canSave = [
    products.name,
    products.isActive,
    products.notifyQty,
    products.CategoryId,
    products.UnitesId,
  ].every(Boolean);

  const canUpdate = [
    products.name,
    products.notifyQty,
    products.CategoryId,
    products.UnitesId,
  ].every(Boolean);

  return (
    <div>
      <div className="block-content-full">
        <div class="block-content">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-4 col-12">
              <form>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group imageBus">
                      <label>
                        <BsFillCameraFill style={{ fontSize: 30 }} /> <br />
                        <span className={file ? "imageName " : "text-dark"}>
                          {file
                            ? "An image is selected "
                            : "Select Product Image (optional)"}
                        </span>
                        <input
                          className="form-control imageFile"
                          type="file"
                          style={{ height: "10px" }}
                          onChange={handleFileChange}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="col-sm-12 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label text-start"
                        >
                          Product Name
                        </label>
                      </div>
                      <input
                        type="text"
                        autoComplete="off"
                        style={{ height: "45px" }}
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Product name"
                        value={products.name}
                        onChange={(e) =>
                          setProducts({ ...products, name: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-sm-12 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="productQuantity"
                          className="form-label text-start"
                        >
                          Product Quantity
                        </label>
                      </div>
                      <div className="input-group">
                        <input
                          type="number"
                          style={{ height: "45px" }}
                          className="form-control numericInput"
                          id="productQuantity"
                          name="productQuantity"
                          placeholder="Product quantity"
                          value={products.Quantity}
                          onChange={(e) =>
                            setProducts({
                              ...products,
                              Quantity: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-sm-6 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="selectSupplier"
                          className="form-label text-start"
                        >
                          Select Supplier
                        </label>
                      </div>
                      <select
                        className="form-select"
                        style={{ height: '45px' }}
                        aria-label="Default select example"
                        id="selectSupplier"
                        onChange={(e) =>
                          setProducts({
                            ...products,
                            supplierId:
                              e.target.value === "Select Supplier"
                                ? 0
                                : e.target.value,
                          })
                        }
                        value={
                          products.supplierId === 0
                            ? "Select Supplier"
                            : products.supplierId
                        }
                      >
                        <option selected>Select Supplier</option>

                        {suppliers?.map((supplier) => (
                          <option key={supplier.id} value={supplier.id}>
                            {supplier.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div> */}

                  <div className="col-sm-12 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="formIsActive"
                          class="form-label text-start "
                        >
                          Activate <FaCheckCircle style={{ color: "green" }} />
                        </label>
                      </div>
                      <select
                        className="form-select"
                        style={{ height: "45px" }}
                        aria-label="Default select example"
                        id="formIsActive"
                        value={products.isActive}
                        onChange={(e) =>
                          setProducts({
                            ...products,
                            isActive: e.target.value,
                          })
                        }
                      >
                        <option value="true">Yes</option>
                        <option selected value="false">
                          No
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-12 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="notificationQuantity"
                          className="form-label text-start"
                        >
                          Notification Quantity
                        </label>
                      </div>
                      <div className="input-group">
                        <input
                          type="number"
                          style={{ height: "45px" }}
                          className="form-control numericInput"
                          id="notificationQuantity"
                          name="notificationQuantity"
                          placeholder="Notification Quantity"
                          value={products.notifyQty}
                          onChange={(e) =>
                            setProducts({
                              ...products,
                              notifyQty: parseInt(e.target.value),
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 hover">
                    <div className="row">
                      <label htmlFor="amount" className="form-label text-start">
                        How much it costs? (optional)
                      </label>
                    </div>
                    <div className="input-group">
                      <input
                        name="amount"
                        style={{ height: "45px" }}
                        type="number"
                        min={"1"}
                        className="form-control numericInput"
                        id="amount"
                        value={products.amount}
                        onChange={(e) =>
                          setProducts({
                            ...products,
                            amount: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  {/* 0  0<div className="col-md-12 hover">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="SelectCategory"
                          className="form-label text-start"
                        >
                          Select Category
                        </label>
                      </div>
                      <select
                        className="form-select"
                        style={{ height: '45px' }}
                        aria-label="Default select example"
                        id="SelectCategory"
                        onChange={(e) => setProducts({ ...products, Category: e.target.value })}
                        value={
                          products.Category === 0
                            ? "Select Category"
                            : products.Category
                        }
                      >
                        <option >Select Category</option>
                        <option value="Hotel">Hotel</option>
                        <option value="Restaurant">Restaurant</option>
                        <option value="Maintenance">Maintenance</option>
                        <option value="Fleet">Fleet</option>
                      </select>
                    </div>
                  </div> */}

                  <div className="mt-2">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="SelectCategory"
                          className="form-label text-start"
                        >
                          Category
                        </label>
                      </div>
                      <select
                        className="form-select"
                        style={{ height: "45px" }}
                        aria-label="Default select example"
                        id="SelectCategory"
                        onChange={(e) =>
                          setProducts({
                            ...products,
                            CategoryId: e.target.value,
                          })
                        }
                        value={
                          products.CategoryId === 0
                            ? "Select Category"
                            : products.CategoryId
                        }
                      >
                        <option selected>Select Category</option>
                        {categories?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="mb-3">
                      <div className="row">
                        <label
                          htmlFor="SelectUnits"
                          className="form-label text-start"
                        >
                          Units
                        </label>
                      </div>
                      <select
                        className="form-select"
                        style={{ height: "45px" }}
                        aria-label="Default select example"
                        id="SelectUnits"
                        onChange={(e) =>
                          setProducts({ ...products, UnitesId: e.target.value })
                        }
                        value={
                          products.UnitesId === 0
                            ? "Select Units"
                            : products.UnitesId
                        }
                      >
                        <option selected>Select Units</option>
                        {Units?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div class="mt-3 pb-3">
                  <button
                    type="submit"
                    class={
                      isUpdate ? "btn btn-success p-2" : "btn btn-primary p-2"
                    }
                    data-dismiss="modal"
                    onClick={
                      isUpdate ? handleUpdateProduct : handleCreateProduct
                    }
                    disabled={isUpdate ? !canUpdate : !canSave}
                  >
                    {isUpdate ? "Update Changes" : "Save changes"}
                  </button>
                  {isUpdate ? (
                    <button
                      type="submit"
                      class={"btn btn-secondary p-2 mx-3"}
                      data-dismiss="modal"
                      onClick={ResetFormChanges}
                    >
                      Reset
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </form>
            </div>
            {/* 
             <div className="d-flex justify-content-between mb-3 align-content-center">
                  <div>
                    <h2 className="content-heading">Products List</h2>
                  </div>

                  <div>
                    <button
                      style={{ background: "#1a2131" }}
                      className="btn btn-success me-2 border-0  text-white"
                      onClick={() => handlePrint()}
                    >
                      <FaDownLong /> Download
                    </button>
                  </div>
                </div>
             */}

            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-8 col-12 bg-light vh-100">
              <div className="d-flex justify-content-between align-items-center p-3 border mt-1">
                <h4 className="text-dark">Products</h4>
                <button
                  className="btn text-white"
                  style={{ background: "#1a2131", height: "40px" }}
                  onClick={handlePrint}
                >
                  <FaDownLong /> Dowload
                </button>
              </div>
              <div className="block-content block-content-full">
                <div className="d-flex m-0">
                  <div className="input-group">
                    <input
                      className="form-control"
                      placeholder="Search..."
                      type="text"
                      style={{ height: "40px" }}
                      onChange={handleSearch}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <IoSearch />
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <DataTable
                title="Products List"
                pointerOnHover
                className="rounded-3"
                columns={_columns}
                data={paginatedData}
                striped
                highlightOnHover
                pagination
                paginationServer
                paginationTotalRows={productsList.length}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[10, 30, 40, 50, 100]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerPageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
